import React from "react";
import { Navigate } from "react-router-dom";

export default function AdminLogin() {
  // Kept for backward compatibility. All logins now go through /login.
  return <Navigate to="/login" replace />;
}
